// =============================================
// NÓ: ACTION (AÇÃO/PROCESSAMENTO) - MOBILE FIRST
// =============================================
// Arquivo: ActionNode.tsx
// Descrição: Nó para executar ações - otimizado para touch
// =============================================

import React from 'react';
import { Handle, Position } from 'reactflow';
import ActionsBadge from './ActionsBadge';
import './NodeStyles.css';

interface ActionNodeProps {
  data: {
    label?: string;
    actionType?: 'save_data' | 'api_call' | 'validate' | 'start_checklist' | 'send_notification';
    description?: string;
    actions?: {
      input?: any[];
      output?: any[];
    };
  };
  selected?: boolean;
}

const ActionNode: React.FC<ActionNodeProps> = ({ data, selected }) => {
  const getIcon = () => {
    switch (data.actionType) {
      case 'save_data': return 'fa-save';
      case 'api_call': return 'fa-cloud';
      case 'validate': return 'fa-check-circle';
      case 'start_checklist': return 'fa-clipboard-check';
      case 'send_notification': return 'fa-bell';
      default: return 'fa-cog';
    }
  };

  return (
    <div className={`custom-node action-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        id="action-input"
        className="node-handle target-handle"
      />
      <div className="node-icon">
        <i className={`fas ${getIcon()}`}></i>
      </div>
      <div className="node-content">
        <div className="node-label">{data.label || 'Ação'}</div>
        {data.description && (
          <div className="node-preview">
            <span>{data.description.substring(0, 30)}{data.description.length > 30 ? '...' : ''}</span>
          </div>
        )}
        <ActionsBadge actions={data.actions} />
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="action-output"
        className="node-handle source-handle"
      />
    </div>
  );
};

export default ActionNode;
